module.exports = __webpack_public_path__ + "img/grayscale-cushwake.c459508a.png";